import * as React from 'react'

import { BoxList } from '@factorialco/deprecated-design-system'
import { DocumentsSignatureStatusEnum } from 'generated/resources/graphql'

import DocumentSignatureStatusBox from 'modules/documents/components/DocumentPreview/Content/Esignature/DocumentSignatureStatusBox'
import SignatureBox from 'modules/documents/components/DocumentPreview/Content/Esignature/SignatureBox'
import type { EsignatureSignature } from 'modules/esignatures/hooks/signatures/useGetEsignatureSignatures'

interface Props {
  signatures: EsignatureSignature[]
  documentSignatureStatus: DocumentsSignatureStatusEnum
  requestDate?: Date
  documentId: string
  signingOrderBySigneeId?: Record<string, number>
}

const SignaturesList = ({
  signatures,
  documentSignatureStatus,
  requestDate,
  documentId,
  signingOrderBySigneeId,
}: Props) => {
  return (
    <BoxList>
      {
        <DocumentSignatureStatusBox
          status={documentSignatureStatus}
          requestDate={requestDate}
          documentId={documentId}
        />
      }
      {signatures.map((signature) => (
        <SignatureBox
          signature={signature}
          key={signature.id}
          order={signingOrderBySigneeId?.[signature.signee?.id ?? '']}
        />
      ))}
    </BoxList>
  )
}

export default SignaturesList
